import React from 'react';
import classNames from 'classnames';

function PanelTitleButtonsGroup({ children }) {
  return (
    <div className={classNames('c-panel__title-buttons-group')}>{children}</div>
  );
}

export default PanelTitleButtonsGroup;
